import { render, staticRenderFns } from "./diseasesynDetail.vue?vue&type=template&id=686421d8&scoped=true"
import script from "./diseasesynDetail.vue?vue&type=script&lang=js"
export * from "./diseasesynDetail.vue?vue&type=script&lang=js"
import style0 from "./diseasesynDetail.vue?vue&type=style&index=0&id=686421d8&prod&scoped=true&lang=css"
import style1 from "./diseasesynDetail.vue?vue&type=style&index=1&id=686421d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686421d8",
  null
  
)

export default component.exports